import { breakpoints } from '../config/breakpoints';

export default function headerMenu() {
  const bodyElement = document.querySelector('body');
  const htmlElement = document.querySelector('html');
  const cHamburger = document.querySelector('#c-hamburger');
  const menu = document.querySelector('.menu');
  const menuImage = document.querySelector('.menu-image');
  const primaryMenuLink = document.querySelectorAll('.primary-nav__link');
  const primaryMenuLinkWrap = document.querySelectorAll('.primary-nav__link-wrap');
  const allButton = document.querySelectorAll('.primary-nav__btn');
  const allMenuImg = document.querySelectorAll('.menu-image__wrap > img');
  const tabIndex = document.querySelectorAll('button, a, input');
  const tabIndexMenu = document.querySelectorAll('.menu button, .menu a, .menu input, .c-hamburger, .header__link');

  // Active link
  let activeElement;

  const downloadImagesAsap = () => {
    allMenuImg.forEach((img) => {
      if (window.innerWidth > breakpoints.md) {
        img.setAttribute('loading', 'eager');
        img.classList.add('menu-image--downloaded');
      } else {
        img.remove();
      }
    });
  };

  const toggleMenu = () => {
    cHamburger.classList.toggle('c-hamburger--open');

    if (cHamburger.classList.contains('c-hamburger--open')) {
      downloadImagesAsap();
      document.body.style.overflow = 'hidden';
      menu.classList.add('menu--active');
      menuImage.classList.toggle('menu-image--active');

      tabIndex.forEach((el) => {
        el.setAttribute('tabindex', -1);
      });

      tabIndexMenu.forEach((el) => {
        el.removeAttribute('tabindex');
      });

      if (cHamburger.classList.contains('c-hamburger--dark')) {
        cHamburger.classList.remove('c-hamburger--dark');
      }

      if (!cHamburger.classList.contains('c-hamburger--light')) {
        cHamburger.classList.add('c-hamburger--light');
      }
      bodyElement.style.overflowY = 'hidden';
      bodyElement.style.height = '100dvh';
      bodyElement.style.maxHeight = '100dvh';
      htmlElement.style.overflowY = 'hidden';
      htmlElement.style.height = '120vh';
      htmlElement.style.maxHeight = '120vh';
    } else {
      document.body.style.overflow = 'auto';
      menu.classList.remove('menu--active');
      menuImage.classList.remove('menu-image--active');
      cHamburger.classList.remove('c-hamburger--light');

      tabIndex.forEach((el) => {
        el.removeAttribute('tabindex');
      });

      bodyElement.removeAttribute('style');
      htmlElement.removeAttribute('style');
    }
  };

  /**
   * Changing the color of the btn to inactive
   * @param btn
   */
  function inactiveColorBtn(btn) {
    btn.classList.remove('primary-nav__btn--active');
    btn.classList.add('primary-nav__btn--not-active');
  }

  /**
   * Сhanging the color of all buttons to inactive ones
   */
  function inactiveColorAllBtn() {
    allButton.forEach((b) => {
      inactiveColorBtn(b);
    });
  }

  /**
   * Changing the color of the link to inactive
   * @param link
   */
  function inactiveColorLink(link) {
    link.classList.remove('primary-nav__link--active');
    link.classList.add('primary-nav__link--not-active');
  }

  /**
   * Сhanging the color of all links to inactive ones
   */
  function inactiveColorAllLink() {
    primaryMenuLink.forEach((link) => {
      inactiveColorLink(link);
    });
  }

  /**
   * Changing the color of the current element to the active one
   * @param currentEl
   */
  function activeColorItem(currentEl) {
    if (activeElement) {
      if (activeElement.dataset.child === 'true') {
        inactiveColorBtn(activeElement.nextElementSibling);
      }
      inactiveColorLink(activeElement);
    } else {
      inactiveColorAllBtn();
      inactiveColorAllLink();
    }

    if (currentEl.dataset.child === 'true') {
      currentEl.nextElementSibling.classList.add('primary-nav__btn--active');
      currentEl.nextElementSibling.classList.remove('primary-nav__btn--not-active');
    }

    currentEl.classList.remove('primary-nav__link--not-active');
    currentEl.classList.add('primary-nav__link--active');
  }

  /**
   * Сlosing the submenu
   * @param btn
   * @param subMenu
   */
  function closeSubMenu(btn, subMenu) {
    const subMenuEl = subMenu;

    window.setTimeout(() => {
      subMenuEl.style.maxHeight = '0px';
      subMenuEl.style.paddingTop = '0px';
      subMenuEl.classList.remove('primary-nav__sub--active');
      btn.classList.remove('primary-nav__btn--open');

      inactiveColorBtn(btn);
    }, 100);
  }

  /**
   * Processing the click on the button
   * @param btn
   * @param subMenu
   */
  function hundlerClickBtn(btn, subMenu) {
    const subMenuEl = subMenu;
    let isActive = false;

    if (subMenu.classList.contains('primary-nav__sub--active')) {
      isActive = true;
    }

    if (subMenu) {
      if (!isActive) {
        subMenuEl.style.paddingTop = '16px';

        const height = subMenuEl.scrollHeight + 16;
        subMenuEl.style.maxHeight = `${height}px`;

        subMenuEl.classList.add('primary-nav__sub--active');
        btn.classList.add('primary-nav__btn--open');
        btn.classList.add('primary-nav__btn--active');
        btn.classList.remove('primary-nav__btn--not-active');
      } else {
        subMenuEl.style.maxHeight = '0px';
        subMenuEl.style.paddingTop = '0px';
        subMenuEl.classList.remove('primary-nav__sub--active');
        btn.classList.remove('primary-nav__btn--open');
      }
    }
  }

  /**
   * We get the button and submenu elements
   * @param el
   * @returns {{}}
   */
  function getBtnAndSubmenu(el) {
    const obj = {};

    obj.btn = el.nextElementSibling;
    obj.subMenu = el.parentElement.nextElementSibling;

    return obj;
  }

  /**
   * Getting the current link element
   * @param el
   * @returns {Element}
   */
  function setCurrentElement(el) {
    let currentEl = el;

    if (el.tagName.toLowerCase() === 'button') {
      currentEl = el.previousElementSibling;
    }

    return currentEl;
  }

  /**
   * Changing the menu image
   * @param currentEl
   */
  function changingMenuImage(currentEl) {
    const idImg = currentEl.dataset.menuimg;

    Array.from(allMenuImg).forEach((el) => {
      const item = el;

      item.style.opacity = '0';
      item.style.visibility = 'hidden';
    });

    if (idImg) {
      const newMenuImg = document.querySelector(`#${idImg}`);

      if (newMenuImg) {
        newMenuImg.style.opacity = '1';
        newMenuImg.style.visibility = 'visible';
      }
    }
  }

  /**
   * Processing the hover event
   */
  function handlerHover() {
    const currentEl = setCurrentElement(this.querySelector('.primary-nav__link'));

    changingMenuImage(currentEl);

    activeColorItem(currentEl);

    if (activeElement && activeElement.dataset.child === 'true' && activeElement !== currentEl) {
      const { btn, subMenu } = getBtnAndSubmenu(activeElement);
      closeSubMenu(btn, subMenu);
    }

    activeElement = currentEl;
  }

  /**
   * Processing the click event
   * @param e
   */
  function handlerClick(e) {
    const btn = e.target.closest('.primary-nav__item')?.querySelector('.primary-nav__btn');
    const subMenu = e.target.closest('.primary-nav__item')?.querySelector('.primary-nav__sub');
    hundlerClickBtn(btn, subMenu);
  }

  /**
   * Processing the focus event
   */
  function handlerFocus() {
    const currentEl = setCurrentElement(this);

    changingMenuImage(currentEl);

    activeColorItem(currentEl);

    if (activeElement && activeElement !== currentEl && activeElement.dataset.child === 'true') {
      const { btn, subMenu } = getBtnAndSubmenu(activeElement);
      closeSubMenu(btn, subMenu);
    }

    activeElement = currentEl;
  }

  /**
   * All Events Menu
   */

  // Event Open/Close Menu
  cHamburger.addEventListener('click', toggleMenu);

  // Handling primary menu link wrap events
  primaryMenuLinkWrap.forEach((el) => {
    el.addEventListener('mouseover', handlerHover);
    el.addEventListener('click', handlerClick);
  });

  // Handling primary menu link events
  primaryMenuLink.forEach((el) => {
    el.addEventListener('focus', handlerFocus);
  });

  // Burger menu keyboard navigation loop
  window.addEventListener('keydown', (event) => {
    const code = event.keyCode ? event.keyCode : event.which;

    if (!cHamburger.classList.contains('c-hamburger--open')) {
      return;
    }

    const pmLinks = window.document.querySelectorAll('.primary-nav__link');
    const pmLinksLastIndex = pmLinks.length - 1;
    let pmLinksLast = pmLinks[pmLinksLastIndex];

    const socialLinks = window.document.querySelectorAll('.menu__social .socials__link');
    const socialLinksLastIndex = socialLinks.length - 1;
    const socialLinksLast = socialLinks[socialLinksLastIndex];

    const smLinks = window.document.querySelectorAll('.secondary-nav__link');
    const smLinksLastIndex = smLinks.length - 1;
    const smLinksLast = smLinks[smLinksLastIndex];

    if (pmLinksLast.dataset.child === 'true') {
      const pmItemsLast = pmLinksLast.closest('.primary-nav__item');
      const pmItemsLastSub = pmItemsLast.querySelector('.primary-nav__sub--active');

      if (pmItemsLastSub) {
        const pmItemsLastSubLinks = pmItemsLastSub.querySelectorAll('.primary-nav__sub-link');
        const pmItemsLastSubLinksLastIndex = pmItemsLastSubLinks.length - 1;
        pmLinksLast = pmItemsLastSubLinks[pmItemsLastSubLinksLastIndex];
      }
    }

    let link;

    if (smLinksLast) {
      link = smLinksLast;
    } else if (socialLinksLast) {
      link = socialLinksLast;
    } else {
      link = pmLinksLast;
    }

    if (link && event.target === link && code === 9 && event.shiftKey === false) {
      event.preventDefault();
      cHamburger.focus();
    }

    if (cHamburger && event.target === cHamburger && code === 9 && event.shiftKey === true) {
      event.preventDefault();
      link.focus();
    }
  });
}
